export const SET_OPTION = 'MODAL_DRAWER_SWITCHER/SET_OPTION';